import { Controller } from "@hotwired/stimulus"
import { createApp } from "vue"

// Lazy registry of all Vue islands. A component at
// app/frontend/components/StatTile.vue is referenced as component-value "StatTile";
// nested paths use slashes: "audits/IssueTable".
const registry = import.meta.glob("../components/**/*.vue")

// Mounts a Vue component as an island inside a server-rendered page.
//
//   <div data-controller="vue-mount"
//        data-vue-mount-component-value="StatTile"
//        data-vue-mount-props-value="<%= { label: 'Issues', value: 42 }.to_json %>">
//   </div>
//
// The island unmounts cleanly when Turbo replaces the element.
export default class extends Controller {
  static values = {
    component: String,
    props: { type: Object, default: {} },
  }

  async connect() {
    this.live = true
    const path = `../components/${this.componentValue}.vue`
    const loader = registry[path]

    if (!loader) {
      console.error(`[vue-mount] Unknown component: ${this.componentValue}`)
      return
    }

    const { default: component } = await loader()
    // Turbo can replace the element while that import is in flight. disconnect
    // has already run by then and found no app to unmount, so mounting here
    // left one on a detached element that nothing would ever tear down — and
    // an island that polls, which the audit explorer does, went on polling for
    // as long as the tab stayed open.
    if (!this.live) return

    this.app = createApp(component, this.propsValue)
    this.app.mount(this.element)
  }

  disconnect() {
    this.live = false
    if (this.app) {
      this.app.unmount()
      this.app = null
    }
  }
}
